// App name: Custom accordion
// Description:
//


const CustomAccordionApp = (function ($) {

  // variables
  // let self = $(this);
  let _accordionEl = $('.elementor-accordion .elementor-accordion-item');

  // init
  function init() {
    //
    customAccordionHandle();
    openAccordionOnHref();
  }

  //function name
  function customAccordionHandle() {
    var outer_ttl = $('.elementor-accordion-item'),
        ttls = outer_ttl.find('.elementor-tab-title'),
        headerh = 70;
    if(outer_ttl.length) {
      outer_ttl.each(function() {
        ttl = $(this).find('.elementor-tab-title');
        var data_id = ttl.attr('data-id');
        if(data_id != '') {
          ttl.attr('id', data_id);
        }
      })
    }

    ttls.on('click', function(){
      setTimeout(() => {
        $('html, body').stop().animate({
          'scrollTop': $(this).offset().top - headerh
        }, 300, 'swing', function () {})
      }, 401);
    })
  }

  function openAccordionOnHref() {
    var delay = 100;
    setTimeout(function() {
      var hash = window.location.hash;
          hash = hash.substring(1);
      if(_accordionEl.length) {
        _accordionEl
        .find('[id='+hash+']').addClass('elementor-active').siblings('.elementor-tab-content').addClass('elementor-active').show()
        .parent().siblings().find('.elementor-tab-title').removeClass('elementor-active').siblings('.elementor-tab-content').removeClass('elementor-active').hide()
      }
    }, delay);
  }

  return {
    init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  CustomAccordionApp.init();
});
